module.exports = __webpack_public_path__ + "static/media/profile-lg.0923e932.png";